import { createSlice } from '@reduxjs/toolkit';
import { fetchJobGradeAction } from '../actions/jobGradeAction';

const initialState: any = {
	data: null,
	isLoading: true,
	error: null,
};

const JobGradeSlice = createSlice({
	name: 'jobGrade',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(fetchJobGradeAction.pending, (state) => {
			state.isLoading = true;
			state.error = null;
		});
		builder.addCase(fetchJobGradeAction.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action?.payload?.data;
		});
		builder.addCase(fetchJobGradeAction.rejected, (state, action: any) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default JobGradeSlice;
